const $ = jQuery.noConflict();
var Match_Height = require("./match-height.js");
var Match_Row = require("./match-row.js");
var Maps = require("./maps.google.js");
var Slider = require("./slider.slick.js");



var self = (module.exports = {
  options: {
    method: "GET",
    url: ajax.ajaxurl,
    dataType: "json",
    contentType: false,
    processData: false,
  },

  init: function (selector) {
    // console.log('selector' , selector);

    self.events.change(selector);
    self.events.page("[data-page]");
    self.events.submit(selector);
    self.events.more("[data-more]");
    self.events.navigate();
    //self.events.getSearchData(selector);
  },

  events: {

    change: function (form) {
      $("input[name=view]").on("click", function () {
        var page = $(form).find('[name="page"]');
        $(page).val(1);
      });

      $(".post-cat-btn").on("click", function(e){
        e.preventDefault();
        var cat_ids = $(this).data('value');
        $(".post-cat-btn").removeClass('active');
        $(this).addClass('active');

        $("#post-search-category").val(cat_ids).change();

      });

      // console.log('get_form 1', form);
      $(form).on(
        "change",
        "input[type=hidden], input[type=radio], input[type=checkbox], input[type=text], select",
        function () {
          if ($(this).attr("name") !== "page") {
            var page = $(form).find('[name="page"]');
            $(page).val(1);
          }
        }
      );

       $('#property-view-sort').on(
        "change",
        function () {
          if ($(this).attr("name") !== "page") {
            var page = $(form).find('[name="page"]');
            $(page).val(1);
          }
        }
      );

      $(".property-search__tenure input[name=tenure]").on("change", function () {
        if ($(this).attr("name") !== "page") {
          var page = $(form).find('[name="page"]');
          $(page).val(1);
        }
        $('.property-search__search').trigger('click')
      });
    },

    page: function (trigger) {
      $(document).on("click", trigger, function (e) {
        var parent = $(this).closest("[data-target]");
        var form = $(parent).data("target");
        var page = $(form).find('[name="page"]');
        var next = parseInt($(this).data("page"));
        e.preventDefault();

        $(page).val(next);
        $(form).trigger("submit");
      });
    },

    more: function (trigger) {
      $(document).on("click", trigger, function (e) {
        var parent = $(this).closest("[data-target]");
        var form = $(parent).data("target");
        var page = $(form).find('[name="page"]');
        var curr = parseInt($(page).val());
        var next = curr + 1;
        $(page).val(next);
        $(form).trigger("submit");
      });
    },

    submit: function (parent) {
      $(document).on("submit", parent, function (e) {
        var form = $(this);
        var data = {};
        var target = $(form).data("target");
        var pagination = $(form).data("pagination");
        var more = $(form).data("more");
        var page = $(form).find('[name="page"]');
        var pageNum = parseInt($(page).val());
        var submit = $(form).find('[type="submit"]');
        

        e.preventDefault();

        // console.table(location,tenure,priceMin,priceMax,bedroomsMin );

        if ($(form).hasClass("submitting")) {
          return;
        }

        if (target && (more === "undefined" || pageNum === 1)) {
          $(target).html("");
          if ($(form).first().attr("data-no-scroll") === undefined) {
            $("html, body").animate(
              {
                //scrollTop: $(target).offset().top,
              },
              200
            );
          }
        }

        if (pagination) {
          $(pagination).each(function () {
            var list = $(this).find("ul");
            $(list).html("");
          });
        }

        if (more) {
          $(more).each(function () {
            $(this).html("");
          });
        }

        $(submit).prop("disabled", true);

        if (pageNum === 1) {
          $(target).removeClass("active");
        }

        data = $(form).serialize();
        var query = "?" + data;
        history.pushState(query, null, query);
        self.service.updateLinks(query);
        self.service.post(form, data);
        self.events.getSearchData(form);
        
        
      });
    },

    navigate: function () {
      window.addEventListener("popstate", function (e) {
        location.reload(true);
      });
    },

    getSearchData: function (form) {
      // var form = $(this);
      // console.log('form', form);

      var location = $(form).find('[name="location"]').val();
      var tenure = $(form).find('[name="tenure"]:checked').val();
      var priceMin = $(form).find('[name="'+tenure+'-price-min"] option:selected');
      var priceMax = $(form).find('[name="'+tenure+'-price-max"] option:selected');
      var bedroomsMin = $(form).find('[name="bedrooms-min"]').val();

      var tenure = tenure == 'sales' ? 'sale' : 'rent';

      //console.table(location,tenure,priceMin,priceMax,bedroomsMin );

      if(!location.length){
        $(".search-data").html(" Property for "+tenure+" in Berkshire");
      }
      if(location.length){
        $(".search-data").html(" Property for "+tenure+" in "+location+" ");
      }

      if(location.length && bedroomsMin != 0){
        $(".search-data").html(" "+bedroomsMin+" bedroom property for "+tenure+" in "+location+" ");
      }

      // if(location.length && (priceMin.length || priceMax.length)){
      //   $(".search-data").html(" Property for "+tenure+" in "+location+" between "+priceMin+" to "+priceMax+" ");
      // }


      if(location.length && priceMin.val() != 0 && priceMax.val() != 999999999999) {
        $(".search-data").html(" Property for "+tenure+" in "+location+" between "+priceMin.text()+" to "+priceMax.text()+" ");
      }
      if(location.length && priceMin.val() != 0 && priceMax.val() != 999999999999 && bedroomsMin != 0) {
        $(".search-data").html(" "+bedroomsMin+" bedroom property for "+tenure+" in "+location+" between "+priceMin.text()+" to "+priceMax.text()+" ");
      }
    },
  },

  service: {
    post: function (form, data) {
      $.ajax({
        method: self.options.method,
        url: self.options.url,
        data: data,
        dataType: self.options.dataType,
        contentType: self.options.contentType,
        processData: self.options.processData,
        success: function (response) {
          self.service.show(response, form);

          // $('html, body').animate({
          //   scrollTop: $(form).offset().top
          // }, 900)
        },
        error: function (data) {
          // console.log(data);
        },
      });
    },

    show: function (response, form) {
      var target = $(form).data("target");
      var pagination = $(form).data("pagination");
      var more = $(form).data("more");
      var count = $(form).data("count");
      var page = $(form).find('[name="page"]');
      var pageNum = parseInt($(page).val());
      var submit = $(form).find('[type="submit"]');
      var button = $(form).data("button");

      if (more && pageNum > 1) {
        var newHtml = $.parseHTML(response.html);
        $(target).children(".row").first().append(newHtml[0].innerHTML);
        Match_Height.init("[data-match-height]");
        Match_Row.init("[data-match-row]");
      } else {
        $(target).html(response.html);
      }

      if (pagination) {
        $(pagination).each(function () {
          var list = $(this).find("ul");
          $(list).html(response.pagination);
        });
      }

      // console.log(more, response);
      if (more) {
        $(more).each(function () {
          $(this).html(response.more);
        });
      }

      if (button) {
        $(button).removeClass("display-none");
      }

      if (count) {
        $(count).html(response.count);
      }

      // console.log(count, response)
      // if (count && response.total === 0) {
      //   $(count).html("");
      // } else if (count) {
      //   if (more === "undefined") {
      //     $(count).find(".count-from").html(response.from);
      //   }

      //   $(count).find(".count-to").html(response.to);
      //   $(count).find(".count-total").html(response.total);
      // }

      var map = $(target).find(".map");
      var slick = $(target).find(".slick");

      if (map) {
        $(map).each(function () {
          Maps.service.initMap(this);
        });
      }

      if (slick.length) {
        $(slick)
          .not(".slick-initialized")
          .each(function () {
            Slider.service.init(this);
          });
      }

      $(target).addClass("loaded");
      $(form).removeClass("submitting");
      $(submit).prop("disabled", false);
      Match_Height.init("[data-match-height]");
      Match_Row.init("[data-match-row]");
      $(window).resize();
    },

    updateLinks: function (query) {
      var propertyPage = $("[name=property-page]").val();
      var mapPage = $("[name=map-page]").val();

      var gridLink = $('[data-view="grid"]');
      var listLink = $('[data-view="list"]');
      var mapLink = $('[data-view="map"]');

      $(gridLink).attr(
        "href",
        propertyPage +
          query
            .replace("view=map", "view=list")
            .replace("view=list", "view=grid")
            .replace("per-page=-1", "per-page=12")
      );
      $(listLink).attr(
        "href",
        propertyPage +
          query
            .replace("view=map", "view=grid")
            .replace("view=list", "view=list")
            .replace("per-page=-1", "per-page=12")
      );
      $(mapLink).attr(
        "href",
        mapPage +
          query
            .replace("view=grid", "view=map")
            .replace("view=list", "view=map")
            .replace("per-page=12", "per-page=-1")
      );
    },

    submit: function (form) {
      $(form).submit();
    },
  },
});
